/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BagCancelPreviousIntentMutationVariables = Types.Exact<{
  input: Types.CancelOrderPaymentIntentInput;
}>;

export type BagCancelPreviousIntentMutation = {
  readonly __typename?: 'Mutation';
  readonly cancelOrderPaymentIntent: {
    readonly __typename: 'CancelOrderPaymentIntentResponse';
    readonly paymentIntentId: string;
    readonly success: boolean;
  };
};

export const BagCancelPreviousIntentDocument = gql`
  mutation BagCancelPreviousIntent($input: CancelOrderPaymentIntentInput!) {
    cancelOrderPaymentIntent(input: $input) {
      __typename
      paymentIntentId
      success
    }
  }
`;

export function useBagCancelPreviousIntentMutation() {
  return Urql.useMutation<
    BagCancelPreviousIntentMutation,
    BagCancelPreviousIntentMutationVariables
  >(BagCancelPreviousIntentDocument);
}
